__turbopack_context__.v({
  "container": "ProductsFlexWrapper-module-scss-module__EAud6G__container",
  "container-2-items": "ProductsFlexWrapper-module-scss-module__EAud6G__container-2-items",
  "container-3-items": "ProductsFlexWrapper-module-scss-module__EAud6G__container-3-items",
  "item-wrapper": "ProductsFlexWrapper-module-scss-module__EAud6G__item-wrapper",
});
